export class UserModel {
    public id: string;
    public name: string;
    public email: string;
    public token: string;
}
